import { apiJson, apiVoid } from './api'

export interface SavedPrompt {
  id: string
  title: string
  body: string
  pinned: boolean
  use_count: number
  last_used_at: string | null
  updated_at: string
}

export async function listPrompts(): Promise<SavedPrompt[]> {
  const data = await apiJson<{ items?: SavedPrompt[] }>('/api/me/prompts')
  return data.items ?? []
}

export async function createPrompt(title: string, body: string): Promise<SavedPrompt> {
  return apiJson<SavedPrompt>('/api/me/prompts', {
    method: 'POST',
    body: JSON.stringify({ title, body }),
  })
}

export async function updatePrompt(
  id: string,
  patch: { title?: string; body?: string; pinned?: boolean },
): Promise<SavedPrompt> {
  return apiJson<SavedPrompt>(`/api/me/prompts/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  })
}

export async function deletePrompt(id: string): Promise<void> {
  await apiVoid(`/api/me/prompts/${id}`, { method: 'DELETE' })
}

/**
 * Kayitli istemi "kullanildi" diye isaretler (sunucuda `use_count` artiyor).
 *
 * Adi `usePrompt` IDI ve bir React hook'u olmadigi halde `use` onekiyle
 * basliyordu: `react-hooks(rules-of-hooks)` kurali onu hook sanip "callback
 * icinde hook cagrilamaz" hatasi veriyordu - deponun TEK lint hatasi buydu.
 */
export async function markPromptUsed(id: string): Promise<void> {
  await apiVoid(`/api/me/prompts/${id}/use`, { method: 'POST' })
}
